import { Auth } from 'aws-amplify';

async function register(request) {
  console.log('userServices.register(): ', request);
  const response = await Auth.signUp({
    username: request.payload.user.email,
    password: request.payload.user.password,
    attributes: {
      email: request.payload.user.email,
    },
  });
  return response;
}

async function login(request) {
  console.log('userServices.login(): ', request);
  const response = await Auth.signIn(request.payload.user.email, request.payload.user.password);
  return response;
}

async function logout() {
  const response = await Auth.signOut();
  return response;
}

async function updateUser(request) {
  console.log('userServices.updateUser(): ', request);
  let user = await Auth.currentAuthenticatedUser();
  await Auth.updateUserAttributes(user, {
    nickname: request.payload.attributes.nickname,
    'custom:height': request.payload.attributes.height,
    'custom:weight': request.payload.attributes.weight,
  });
  user = await Auth.currentAuthenticatedUser();
  return user;
}

async function updateUserPicture(request) {
  console.log('userServices.updateUserPicture(): ', request);
  let user = await Auth.currentAuthenticatedUser();
  await Auth.updateUserAttributes(user, {
    picture: request.payload.attributes.picture,
  });
  user = await Auth.currentAuthenticatedUser();
  return user;
}

const userServices = {
  register,
  login,
  logout,
  updateUser,
  updateUserPicture,
};

export default userServices;
